export type Farm = {
  id: string;
  companyId: string;
  tapCompanyId: string;
  sharedAccess: boolean;
  sharedAccessLevel: string;
  farmNumber: number;
  farmName: string;
  farmerName: string;
  address: string;
  address2?: string;
  zipCode: string;
  city: string;
  country: string;
  region: string;
  phone1: string;
  phone2: string;
  email: string;
  uniqueId: string;
  farmType: string;
};

export enum FarmType {
  BEEF = 'beef',
  DAIRY = 'dairy',
}
